var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgDropdownGe = function SvgDropdownGe(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 10,
    viewBox: "0 0 17 10",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_54164",
    "data-name": "Group 54164",
    transform: "translate(0 10) rotate(-90)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5334",
    "data-name": "Rectangle 5334",
    width: 3.333,
    height: 3.4,
    transform: "translate(6.667)",
    fill: "#15081f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5335",
    "data-name": "Rectangle 5335",
    width: 3.333,
    height: 3.4,
    transform: "translate(3.333 3.4)",
    fill: "#15081f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5338",
    "data-name": "Rectangle 5338",
    width: 3.333,
    height: 3.4,
    transform: "translate(0 6.8)",
    fill: "#15081f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5339",
    "data-name": "Rectangle 5339",
    width: 3.333,
    height: 3.4,
    transform: "translate(6.667 13.6)",
    fill: "#15081f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5337",
    "data-name": "Rectangle 5337",
    width: 3.333,
    height: 3.4,
    transform: "translate(3.333 10.2)",
    fill: "#15081f"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDropdownGe, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dropdown-ge.8e285bde.svg";
export { ForwardRef as ReactComponent };